<template>

  <div id="termsPopupBox" class="termsPopup">
    <div class="terms-popup-content">
      <!-- Header -->
      <div class="terms-popup-header">
        <h2>Terms and conditions</h2>
      </div>

      <!-- Content -->
      <div class="terms-popup-main">
      <h3>
        Please carefully read the terms and conditions below. <br>
        Only use the tool if you agree to these. Otherwise, you cannot proceed.
      </h3>

      <!-- Line with margin -->
      <hr/>

      <h4>Background</h4>
      SPURS has been developed by EY-Parthenon and is a Monte Carlo simulation tool that is run in your browser.
      <br>
      <br>
      Lorem ipsum dolor sit amet consectetur adipiscing elit, est quis dictumst porta fringilla tempor, semper aliquam phasellus turpis sociosqu lectus. Natoque ad leo felis quis class egestas placerat sed integer, ultricies habitasse faucibus nisl turpis urna posuere convallis tellus, eget eu ullamcorper torquent primis curabitur fringilla lacinia. Praesent in aptent interdum lacus luctus rutrum nascetur convallis, sagittis natoque iaculis commodo pulvinar quisque etiam primis, nunc cubilia tempus turpis fames viverra sollicitudin.
      <br>
      Curae purus maecenas suspendisse netus cum dictum rhoncus accumsan montes, dui habitasse magnis natoque laoreet penatibus sodales orci. At habitant massa lectus libero tempor porta inceptos ridiculus pharetra, dis natoque fermentum sapien montes ultrices sagittis conubia, semper volutpat purus platea cursus class leo pulvinar. Nam eleifend iaculis neque in augue arcu ultricies nisi urna, magnis auctor nullam viverra quisque hendrerit mauris sem conubia id, magna senectus ullamcorper quam dis porta fermentum odio.
      
      <h4>Terms and conditions</h4>
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND...
      <br>
      <br>
      Lorem ipsum dolor sit amet consectetur adipiscing elit, est quis dictumst porta fringilla tempor, semper aliquam phasellus turpis sociosqu lectus. Natoque ad leo felis quis class egestas placerat sed integer, ultricies habitasse faucibus nisl turpis urna posuere convallis tellus, eget eu ullamcorper torquent primis curabitur fringilla lacinia. Praesent in aptent interdum lacus luctus rutrum nascetur convallis, sagittis natoque iaculis commodo pulvinar quisque etiam primis, nunc cubilia tempus turpis fames viverra sollicitudin.
      <br>
      Curae purus maecenas suspendisse netus cum dictum rhoncus accumsan montes, dui habitasse magnis natoque laoreet penatibus sodales orci. At habitant massa lectus libero tempor porta inceptos ridiculus pharetra, dis natoque fermentum sapien montes ultrices sagittis conubia, semper volutpat purus platea cursus class leo pulvinar. Nam eleifend iaculis neque in augue arcu ultricies nisi urna, magnis auctor nullam viverra quisque hendrerit mauris sem conubia id, magna senectus ullamcorper quam dis porta fermentum odio.
      
      <!-- Line with margin -->
      <hr/>
      
      <div style="display: flex;">
        <button v-on:click="closeTerms()">
          I agree.
        </button>
      </div>

      </div>
    </div>
  </div>

</template>


<script>

  import Vue from 'vue';

  export default {

    name: 'Terms',
    props: [],
    data: () => {
      return {
        
      }
    },
    mounted() {
     // console.log('I am mounted!')

    },

    methods: {

      // The method below is called when the user clicks the 'x' in the popup.
      // See the v-on:click directive
      closeTerms(){
        Vue.prototype.$eventHub.$emit("showTermsEvent", false);
      }

    }
  }

</script>


<style scoped>

  img {
    display: block;
  }

/* Scrollbar */

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

/* Popup Box */
  
  #termsPopupBox {
    z-index: 100;
  }

  /* mPopup box style */
  .termsPopup {
    position: fixed;
    z-index: 1;
    padding-top: 50px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.8);
  }

  .terms-popup-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 0;
    width: 1100px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s
  }

  .terms-popup-header {
    padding: 2px 16px;
    background-color: #51A7DD;
    color: white;
  }

  .terms-popup-main {
    /* This is the part of the pop-up underneath the pop-up header */

    padding: 20px 16px;
    overflow:auto;

  }

  .popup-footer {
    padding: 2px 16px;
    background-color: #999999;
    color: #ffffff;
    font-family: monospace;
    font-size: 12px;
  }

  button {
    justify-content: center;
/*     display: block; */
    font-size: 20px;
    font-weight: bold;
    margin: 0 auto;
  }

  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 2em 0;
    padding: 0;
}

  
</style>